import styled from 'styled-components';

import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import { IFieldEditor } from '@/shared/types/fieldEditor';
import { themeVar } from '@/styles/theme';
import { useMutation } from '@apollo/client';
import { DUE_DILIGENCE_RECORD_QUERY, RELINK_DUE_DILIGENCE_RECORD_FIELD_ANSWER_MUTATION } from '../queries';

interface RelinkFieldProps {
  onClose: () => void;
  isOpen: boolean;
  currentField: IFieldEditor | null;
  recordId: string | null;
}

const RelinkField = ({ onClose, isOpen, currentField, recordId }: RelinkFieldProps) => {
  const [relinkFieldAnswer] = useMutation(RELINK_DUE_DILIGENCE_RECORD_FIELD_ANSWER_MUTATION, {
    refetchQueries: () => [
      {
        query: DUE_DILIGENCE_RECORD_QUERY,
        variables: {
          id: recordId
        }
      }
    ]
  });

  const saveValue = () => {
    relinkFieldAnswer({
      variables: {
        id: currentField.fieldAnswerId
      },
      onCompleted: () => {
        onClose();
      }
    });
  };

  if (!recordId || !currentField?.linkedField) return <></>;

  return (
    <ModalWrappedContent isOpen={isOpen} onClose={onClose} confirmButton={{ name: 'Confirm', onClick: saveValue }}>
      <ModalContainer>
        <ModalTitel>Confirmation</ModalTitel>
        <ModalText>
          Do you want to discard your revised answer for this field and relink it to the corresponding field on{' '}
          {currentField?.linkedField?.funnelTierSection?.funnelTier?.name}? Your revised answer will not be recoverable.
        </ModalText>
      </ModalContainer>
    </ModalWrappedContent>
  );
};

export default RelinkField;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ModalTitel = styled.div`
  font-size: 33px;
  text-align: center;
  color: ${themeVar('font.strong')};
`;

const ModalText = styled.p`
  font-weight: 400;
  font-size: 19px;
  line-height: 26.6px;
  text-align: center;
  color: ${themeVar('font.base')};
`;
